import declareCianSentryConfiguration from '@cian/sentry';
import { calculateEnvironmentByHost } from '@cian/utils/lib/shared/calculate_environment_by_host';

export default function initSentry() {
  const environment: string = calculateEnvironmentByHost(window.location.host);

  declareCianSentryConfiguration({
    dsn: 'http://e5b834e9a940484db1ac6636757e92a9@sentry-front.cian.ru/2',
    environment,
    release: process.env.SENTRY_RELEASE || 'local',
    matchUrl: (url: string) => {

      if (/\/add-form(\.\w+(\d+)?)?(\.js)/i.test(url) || /(\/)?serp.*(\.js)/.test(url)) {
        return false;
      }

      return [
        /cian\.ru/i,
      ].some(t => t.test(url));
    },
  });
}



// WEBPACK FOOTER //
// ./src/bundles/sentry/index.ts